import fieldMixin from '@maison/mixins/fieldMixin';
import TextField from '@maison/components/form/fields/TextField.vue';
import { phoneField } from '@maison/Toolkit';

export default {
  components: {
    TextField,
  },

  mixins: [fieldMixin],

  props: {
    country: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      phoneField: null,
      valueWithoutDialCode: '',
    };
  },

  inject: {
    setPhoneCountryData: {
      default() {
        return () => {};
      },
    },
  },

  computed: {
    value: {
      get() {
        return this.valueWithoutDialCode;
      },
      set() {
        this.emitValue();
      },
    },
  },

  watch: {
    modelValue: {
      handler() {
        this.setValueWithoutDialCode();
      },
      immediate: true,
    },
  },

  async mounted() {
    const input = this.$refs.fieldRef.$refs[this.field.id];

    input.addEventListener('countrychange', () => {
      this.setValueWithoutDialCode();
      this.emitValue();
    });

    const currentCountry = window.Phoenix.currentCountry;
    this.phoneField = await phoneField(input, {
      dialCodeLabel: this.$t('Accessibility.form.phoneField.dialCodeLabel'),
      initialCountry: currentCountry !== 'INT' ? currentCountry : '',
      separateDialCode: this.isDialCodeSeparated(),
      useFullscreenPopup: false,
    });

    this.setValueWithoutDialCode();
  },

  beforeDestroy() {
    if (this.phoneField) {
      this.phoneField.destroy();
    }
  },

  methods: {
    emitValue() {
      this.$emit('update:modelValue', this.phoneField.getNumber());
      this.setPhoneCountryData(this.phoneField.getSelectedCountryData());
    },

    setValueWithoutDialCode() {
      const dialCode = this.phoneField?.getSelectedCountryData().dialCode;
      this.valueWithoutDialCode = dialCode ? this.modelValue.replace(`+${dialCode}`, '') : this.modelValue;
    },

    isDialCodeSeparated() {
      return true;
    },
  },
};
